import React, { useState } from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import MainForm from "../../components/form/MainForm";
import TriggerForm from "../../components/form/TriggerForm";
import WorkflowCanvas from "../../components/workflow3/WorkflowCanvas";
import AiWorkflowForm from "../../components/workflow3/AiWorkflowForm";
import BotExecutions from "./BotExecutions";
import WorkflowExecutions from "./WorkflowExecutions";

const Sidebar = ({ toggleSidebar, openModal }) => {
  return (
    <div className="">
      <button
        onClick={openModal}
        className={`flex justify-center items-center gap-2 rounded-xl px-3 py-2 cursor-pointer bg-primary-gradient text-white w-full ${toggleSidebar && "font-bold text-1xl"
          }`}
      >
        {toggleSidebar ? "+" : "Create Trigger"}
      </button>
    </div>
  );
};

const Workflow = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const [showWorkflowCanvas, setShowWorkflowCanvas] = useState(false);
  const [aiWorkflowModalOpen, setAiWorkflowModalOpen] = useState(false);
  const [workflowType, setWorkflowType] = useState("bot"); // bot, workflow

  return (
    <BaseLayout
      sidebar={<Sidebar />}
      tabBarAbsolute={true}
      createName="New Workflow"
      handleCreate={workflowType === "bot" ? openModal : () => setShowWorkflowCanvas(true)}
      leftSide={
        workflowType === "workflow" ? <WorkflowExecutions /> : <BotExecutions />
      }
    >
      <div className="h-full w-full flex flex-col gap-3">
        <MainForm setWorkflowType={setWorkflowType} />
        <TriggerForm isModalOpen={isModalOpen} closeModal={closeModal} />
        <div className="relative">
          <div className="absolute  hidden -top-7 left-1/2 transform -translate-x-1/2 sm:flex text-xs items-center gap-4 w-full justify-center">
            <button
              onClick={() => {
                if (workflowType === "bot") openModal();
                else if (workflowType === "workflow") setShowWorkflowCanvas(true);
              }}
              className="bg-zinc-800 sm:px-3 py-1 rounded-lg flex items-center gap-2 hover:bg-opacity-70 transition-all duration-200 border border-zinc-700"
            >
              + Create workflow
            </button>
          </div>
        </div>
      </div>
      {showWorkflowCanvas && (
        <WorkflowCanvas
          closeModal={() => {
            setShowWorkflowCanvas(false);
          }}
        />
      )}
      {aiWorkflowModalOpen && (
        <AiWorkflowForm
          isModalOpen={aiWorkflowModalOpen}
          closeModal={() => setAiWorkflowModalOpen(false)}
        />
      )}
    </BaseLayout>
  );
};

export default Workflow;
